/* TODO: t() */
import querystring from 'querystring';
import { fetchData } from '../../../support/Fetch';

export type PaymentSpringRequiredAchTokenParams = {
  token_type: 'bank_account';
  bank_account_number: string;
  bank_routing_number: string;
  bank_account_holder_first_name: string;
  bank_account_holder_last_name: string;
  bank_account_type: 'checking' | 'savings';
};

type PaymentSpringTokenParams =
  | {
      token_type: 'credit_card';
      card_owner_name?: string;
      card_number: string;
      card_exp_month: number;
      card_exp_year: number;
      address_1?: string;
      address_2?: string;
      city?: string;
      state?: string;
      zip?: string;
      country?: string;
      cvv: string;
    }
  | (PaymentSpringRequiredAchTokenParams & {
      address_1?: string;
      address_2?: string;
      city?: string;
      state?: string;
      zip?: string;
      country?: string;
    });

type PaymentSpringTokenResponse = {
  id: string;
  class: string;
  card_type: string;
  card_owner_name: string;
  last_4: string;
  card_exp_month: number;
  card_exp_year: number;
  errors?: Array<{ code: string; message: string }>;
};

export async function createPaymentSpringToken(
  tokenParams: PaymentSpringTokenParams,
  paymentSpringPublicApi: string,
) {
  // TODO: Do we need to add a leading zero on the month? Currently it will be
  // sent without it, which aligns with the examples in PaymentSpring's docs.
  let queryString = querystring.stringify({
    ...tokenParams,
    public_api_key: paymentSpringPublicApi,
  });

  // PaymentSpring requires us to use a JSONP endpoint here, but evidently this
  // endpoint also supports CORS and since we are not specifying a callback
  // param we get back normal JSON.
  let urlWithQueryString = `https://api.paymentspring.com/api/v1/tokens/jsonp?${queryString}`;
  let response = await fetchData(urlWithQueryString);
  if (typeof response?.id === 'string') {
    return response as PaymentSpringTokenResponse;
  }
  return undefined;
}
